// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1i0gB","label":"Section_label__3C4ms","contentWrap":"Section_contentWrap__3riGY","footer":"Section_footer__1ivaq","footerInner":"Section_footerInner__3_XFr"};